import _ from 'lodash'
import { createRouter, createWebHistory } from 'vue-router'

import DashboardView from '@/views/DashboardView.vue'

import PageNotFound from '@/pages/utility/PageNotFound.vue'

import Landing from '@/pages/Landing.vue'
import LoginPage from '@/pages/LoginPage.vue'
// import SignUp from './pages/SignUp.vue'
import ForgotPassword from '@/pages/ForgotPassword.vue'
import ResetPassword from '@/pages/ResetPassword.vue'
import NoAccess from '@/pages/NoAccess.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import RegisterVerifyPage from '@/pages/RegisterVerifyPage.vue'
import OnboardPage from '@/pages/OnboardPage.vue'

import SupercampaignsList from '@/pages/SupercampaignsList.vue'
import SupercampaignPage from '@/pages/SupercampaignPage.vue'

import SupercampaignHomeSubpage from '@/subpages/SupercampaignHomeSubpage.vue'
import SupercampaignSettingsSubpage from '@/subpages/SupercampaignSettingsSubpage.vue'
import CampaignCreatorsSubpage from '@/subpages/CampaignCreatorsSubpage.vue'
import CampaignReportSubpage from '@/subpages/CampaignReportSubpage.vue'
import CampaignReportSteamSubpage from '@/subpages/CampaignReportSteamSubpage.vue'
import CampaignSlotsSubpage from '@/subpages/CampaignSlotsSubpage.vue'
import CampaignApprovalSubpage from '@/subpages/CampaignApprovalSubpage.vue'
import CampaignWorkflowSubpage from '@/subpages/CampaignWorkflowSubpage.vue'
import CampaignFinanceSubpage from '@/subpages/CampaignFinanceSubpage.vue'
import CampaignTargetingSubpage from '@/subpages/CampaignTargetingSubpage.vue'
import CampaignDeliverablesSubpage from '@/subpages/CampaignDeliverablesSubpage.vue'
import CampaignBidSubpage from '@/subpages/CampaignBidSubpage.vue'
import CampaignOutreachSubpage from '@/subpages/CampaignOutreachSubpage.vue'
import EditProfilePage from '@/pages/EditProfilePage.vue'
import ListsPage from '@/pages/ListsPage.vue'
import DiscoverPage from '@/pages/DiscoverPage.vue'
import IndustriesPage from '@/pages/IndustriesPage.vue'
import IndustryDetailPage from '@/pages/IndustryDetailPage.vue'
import RosterPage from '@/pages/RosterPage.vue'
import BidsPage from '@/pages/BidsPage.vue'
import ReturnPage from '@/pages/ReturnPage.vue'
import MessagesPage from '@/pages/MessagesPage.vue'
import ReportsPage from '@/pages/ReportsPage.vue'

import GamesList from '@/pages/GamesList.vue'
import GamePage from '@/pages/GamePage.vue'
import GameFeedSubpage from '@/subpages/GameFeedSubpage.vue'
import GameKeySubpage from '@/subpages/GameKeySubpage.vue'

import OrganizationPage from '@/pages/OrganizationPage.vue'
import OrganizationFeedSubpage from '@/subpages/OrganizationFeedSubpage.vue'
import OrganizationDatasourcesSubpage from '@/subpages/OrganizationDatasourcesSubpage.vue'
import OrganizationManagementSubpage from '@/subpages/OrganizationManagementSubpage.vue'
import OrganizationPermissionsSubpage from '@/subpages/OrganizationPermissionsSubpage.vue'
import OrganizationSettingsSubpage from '@/subpages/OrganizationSettingsSubpage.vue'
import OrganizationSubscriptionsSubpage from '@/subpages/OrganizationSubscriptionsSubpage.vue'
import OrganizationUsageSubpage from '@/subpages/OrganizationUsageSubpage.vue'
import OrganizationUnlockedCreatorsSubpage from '@/subpages/OrganizationUnlockedCreatorsSubpage.vue'
import OrganizationEmailAccountsSubpage from '@/subpages/OrganizationEmailAccountsSubpage.vue'

import AdminLayoutPage from '@/pages/AdminLayout.vue'
import AdminOrganizationsSubpage from '@/subpages/AdminOrganizationsSubpage.vue'
import AdminSystemStatusSubpage from '@/subpages/AdminSystemStatusSubpage.vue'

import AiChatPage from '@/pages/AiChatPage.vue'

import PlaygroundPage from '@/pages/PlaygroundPage.vue'
import PlaygroundLayoutsSubpage from '@/subpages/PlaygroundLayoutsSubpage.vue'
import PlaygroundTypographySubpage from './subpages/PlaygroundTypographySubpage.vue'
import PlaygroundButtonsSubpage from './subpages/PlaygroundButtonsSubpage.vue'

const routerHistory = createWebHistory()

const router = createRouter({
    history: routerHistory,

    routes: [
        {
            name: 'landing',
            path: '/',
            component: Landing,
        },
        {
            name: 'login',
            path: '/login',
            component: LoginPage,
        },
        {
            name: 'forgot-password',
            path: '/forgot-password',
            component: ForgotPassword,
        },
        {
            name: 'reset-password',
            path: '/reset-password',
            component: ResetPassword,
        },
        {
            name: 'register-verify',
            path: '/register/verify',
            component: RegisterVerifyPage,
            meta: {
                trackGtm: true,
            },
        },
        {
            name: 'register',
            path: '/register',
            component: RegisterPage,
            meta: {
                trackGtm: true,
            },
            redirect : { name: 'login' },
        },
        {
            name: 'onboarding',
            path: '/onboarding',
            component: OnboardPage,
            meta: {
                has_authentication: true,
                trackGtm: true,
            },
        },
        {
            path: '/',
            name: 'dashboard-root',
            component: DashboardView,
            meta: {
                has_authentication: true,
            },
            children: [
                {
                    name: 'ai-chat',
                    path: '/chat',
                    component: AiChatPage,
                    meta: {
                        has_authentication: true,
                    },
                },
                {
                    name: 'ai-chat-conversation',
                    path: '/chat/:conversationId',
                    component: AiChatPage,
                    meta: {
                        has_authentication: true,
                    },
                },
                {
                    name: 'admin',
                    path: '/admin',
                    component: AdminLayoutPage,
                    meta: {
                        has_authentication: true,
                    },
                    children: [
                        {
                            name: 'admin-default',
                            path: '',
                            redirect: '/admin/organizations',
                        },
                        {
                            name: 'admin-organizations',
                            path: 'organizations',
                            component: AdminOrganizationsSubpage,
                            meta: {
                                has_authentication: true,
                            },
                        },
                        {
                            name: 'admin-system-status',
                            path: 'system-status',
                            component: AdminSystemStatusSubpage,
                            meta: {
                                has_authentication: true,
                            },
                        },
                    ],
                },
                {
                    name: 'edit-profile',
                    path: 'edit-profile',
                    component: EditProfilePage,
                },
                {
                    name: 'campaigns',
                    path: 'campaigns',
                    component: SupercampaignsList,
                    meta: {
                        permissions: ['module.campaigns'],
                    },
                },
                {
                    name: 'supercampaign',
                    path: 'campaigns/:supercampaign_id',
                    component: SupercampaignPage,
                    meta: {
                        permissions: ['module.campaigns'],
                    },
                    children: [
                        {
                            name: 'supercampaign-home',
                            path: 'home',
                            component: SupercampaignHomeSubpage,
                        },
                        {
                            name: 'supercampaign-settings',
                            path: 'settings',
                            component: SupercampaignSettingsSubpage,
                        },
                        {
                            name: 'campaign-creators',
                            path: 'module/:campaign_id/creators',
                            component: CampaignCreatorsSubpage,
                        },
                        {
                            name: 'campaign-report',
                            path: 'module/:campaign_id/report',
                            component: CampaignReportSubpage,
                        },
                        {
                            name: 'campaign-report-steam',
                            path: 'module/:campaign_id/report-steam',
                            component: CampaignReportSteamSubpage,
                        },
                        {
                            name: 'campaign-slots',
                            path: 'module/:campaign_id/slots',
                            component: CampaignSlotsSubpage,
                        },
                        {
                            name: 'campaign-approval',
                            path: 'module/:campaign_id/approval',
                            component: CampaignApprovalSubpage,
                        },
                        {
                            name: 'campaign-workflow',
                            path: 'module/:campaign_id/workflow',
                            component: CampaignWorkflowSubpage,
                        },
                        {
                            name: 'campaign-deliverables',
                            path: 'module/:campaign_id/deliverables',
                            component: CampaignDeliverablesSubpage,
                        },
                        {
                            name: 'campaign-finance',
                            path: 'module/:campaign_id/finance',
                            component: CampaignFinanceSubpage,
                        },
                        {
                            name: 'campaign-targeting',
                            path: 'module/:campaign_id/targeting',
                            component: CampaignTargetingSubpage,
                        },
                        {
                            name: 'campaign-bids',
                            path: 'module/:campaign_id/bids',
                            component: CampaignBidSubpage,
                        },
                        {
                            name: 'campaign-outreach',
                            path: 'module/:campaign_id/outreach',
                            component: CampaignOutreachSubpage,
                        },
                    ],
                },
                {
                    name: 'games',
                    path: 'games',
                    component: GamesList,
                    meta: {
                        permissions: ['module.games'],
                    },
                },
                {
                    name: 'game',
                    path: 'games/:game_id',
                    component: GamePage,
                    meta: {
                        permissions: ['module.games'],
                    },
                    children: [
                        {
                            name: 'game-feed',
                            path: 'feed',
                            component: GameFeedSubpage,
                        },
                        {
                            name: 'game-keys',
                            path: 'keys',
                            component: GameKeySubpage,
                        },
                    ],
                },
                {
                    name: 'organization',
                    path: 'organizations/:organization_id',
                    component: OrganizationPage,
                    children: [
                        {
                            name: 'organization-feed',
                            path: 'feed',
                            component: OrganizationFeedSubpage,
                        },
                        {
                            name: 'organization-datasources',
                            path: 'datasources',
                            component: OrganizationDatasourcesSubpage,
                        },
                        {
                            name: 'organization-users',
                            path: 'users',
                            component: OrganizationManagementSubpage,
                        },
                        {
                            name: 'organization-permissions',
                            path: 'permissions',
                            component: OrganizationPermissionsSubpage,
                        },
                        {
                            name: 'organization-subscriptions',
                            path: 'subscriptions',
                            component: OrganizationSubscriptionsSubpage,
                        },
                        {
                            name: 'organization-settings',
                            path: 'settings',
                            component: OrganizationSettingsSubpage,
                        },
                        {
                            name: 'organization-usage',
                            path: 'usage',
                            component: OrganizationUsageSubpage,
                        },
                        {
                            name: 'organization-unlocked-creators',
                            path: 'unlocked-creators',
                            component: OrganizationUnlockedCreatorsSubpage,
                        },
                        {
                            name: 'organization-email-accounts',
                            path: 'email-accounts',
                            component: OrganizationEmailAccountsSubpage,
                             meta: {
                                permissions: ['feature.messages.integration'],
                            },
                        },
                    ],
                },
                {
                    name: 'lists',
                    path: 'lists',
                    component: ListsPage,
                    meta: {
                        permissions: ['module.lists'],
                    },
                },
                {
                    name: 'discovery',
                    path: 'discover',
                    component: DiscoverPage,
                    meta: {
                        permissions: ['module.discovery'],
                    },
                },
                {
                    name: 'industries',
                    path: 'industries',
                    component: IndustriesPage,
                    meta: {
                        permissions: ['admin.access'],
                    },
                },
                {
                    name: 'industry-detail',
                    path: 'industries/:industry_name',
                    component: IndustryDetailPage,
                    meta: {
                        permissions: ['admin.access'],
                    },
                },
                {
                    name: 'industry-category-detail',
                    path: 'industries/:industry_name/:category_name',
                    component: IndustryDetailPage,
                    meta: {
                        permissions: ['admin.access'],
                    },
                },
                {
                    name: 'roster',
                    path: 'roster',
                    component: RosterPage,
                },
                {
                    name: 'bids',
                    path: 'bids',
                    component: BidsPage,
                },
                {
                    name: 'messages',
                    path: 'messages',
                    component: MessagesPage,
                    meta: {
                        permissions: ['module.messages', 'feature.messages.integration'],
                    },
                },
                {
                    name: 'reports',
                    path: 'reports',
                    component: ReportsPage,
                    meta: {
                        // permissions: ['module.reports'],
                    },
                },
                {
                    name: 'no-access',
                    path: '/no-access',
                    component: NoAccess,
                },
                {
                    name: 'return',
                    path: '/return',
                    component: ReturnPage,
                },
                {
                    name: 'playground',
                    path: '/playground',
                    component: PlaygroundPage,
                    meta: { has_authentication: true, requiresDevMode: true },
                },
                {
                    name: 'playground-layouts',
                    path: '/playground/layouts',
                    component: PlaygroundLayoutsSubpage,
                    meta: { has_authentication: true, requiresDevMode: true },
                },
                {
                    name: 'playground-typography',
                    path: '/playground/typography',
                    component: PlaygroundTypographySubpage,
                    meta: { has_authentication: true, requiresDevMode: true },
                },
                {
                    name: 'playground-buttons',
                    path: '/playground/buttons',
                    component: PlaygroundButtonsSubpage,
                    meta: { has_authentication: true, requiresDevMode: true },
                },
            ],
        },

        // Fallback
        {
            path: '/:pathMatch(.*)*',
            component: PageNotFound,
        },
    ],
})

const routerInit = (store, app) => {
    router.beforeEach(async (to, from, next) => {
        // We do this check to make sure we don't cancel requests if it's a hash change
        // Might be unintentional side-effects of this
        if (to.name !== from.name) {
            // console.log(`Route changed, cancelling requests`, { to, from })
            store.dispatch('CANCEL_PENDING_REQUESTS')
        }

        if (to.matched.some((m) => m.meta.has_authentication) && !store.state.authentication.is_authenticated) {
            /*
             * If the user is not authenticated and visits
             * a page that requires authentication, redirect to the login page
             * but save the attempted path to localstorage so we can redirect
             * the user there after login
             */
            store.commit('authentication:redirect', to.fullPath)

            next({
                name: 'login',
            })
        } else if (to.matched.some((m) => m.meta.guest) && store.state.authentication.is_authenticated) {
            /*
             * If the user is authenticated and visits
             * an guest page, redirect to the dashboard page
             */
            next({
                name: 'login',
            })
        } else if (to.matched.some((m) => m.meta.requiresDevMode) && !store.state.self.isDevModeEnabled) {
            /*
             * If the user is not in dev mode and visits
             * a page that requires dev mode, redirect to the discovery page
             * at this point they are authenticated, just not in dev mode
             */
            next({
                name: 'discovery',
            })
        } else {
            const isOperatorAuthed = store.state.authentication.is_authenticated
            const hasRouteWithPermissionsCheck = to.matched.some((matchedRoute) => matchedRoute?.meta?.permissions)
            const isHomepage = to?.path === '/'

            if (isOperatorAuthed && (hasRouteWithPermissionsCheck || isHomepage)) {
                const waitPerCycle = 50
                const waitTimeout = 5000
                let waited = 0

                while (store.getters.isPermissionsLoaded === false) {
                    // eslint-disable-next-line no-await-in-loop, no-promise-executor-return
                    await new Promise((resolve) => setTimeout(resolve, waitPerCycle))
                    waited += waitPerCycle

                    if (waited >= waitTimeout) {
                        router.push({
                            name: 'no-access',
                            query: { reason: 'timeout' },
                        })

                        break
                    }
                }

                const isAllRoutesPermitted = to.matched.every((matchedRoute) => {
                    // console.log(matchedRoute, matchedRoute?.meta?.permissions)

                    if (matchedRoute?.meta?.permissions) {
                        return _.every(matchedRoute.meta.permissions, (permissionId) => {
                            return store.getters.checkPermission(permissionId)
                        })
                    }

                    return true
                })

                if (!isAllRoutesPermitted) {
                    // console.log(`No access triggered`)
                    next({
                        name: 'no-access',
                        query: { reason: 'permission-denied' },
                    })

                    // We passed the permissions checks
                } else {
                    // console.log(`We passed the permissions checks`)
                    next()
                }

                // There were never any permissions checks
            } else {
                // console.log(`There were never any permissions checks`)
                next()
            }
        }

        // eslint-disable-next-line no-cond-assign
        for (let matched = to.matched || [], i = matched.length; (i -= 1); ) {
            const route = matched[i]

            if (route.beforeEnter) {
                route.beforeEnter(to, from, next)
            }
        }
    })

    if (import.meta.env.MODE === 'production') {
        router.afterEach((to) => {
            // Only track views when route.meta.trackGtm is true
            if (to.meta.trackGtm) {
                // name or path can be passed as view name
                app.config.globalProperties.$gtm.trackView(to.meta.gtmViewName || to.name || to.fullPath)
            }
        })
    }

    return router
}

export default routerInit
